import { getAlertId, useAlertStore } from '../../store/alertStore';
import { stylesheet } from 'typestyle';
import { Alert, IAlertButtonProps } from '@traceair/tds';
import { useNetworkAlert } from '../../hooks/useNetworkStatus';
import { CloseIcon } from '@traceair/webapp-icons';

const css = stylesheet({
  container: {
    position: 'fixed',
    bottom: 8,
    left: 0,
    right: 0,
    width: 350,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: '90%',
    margin: 'auto',
    zIndex: 1000,
  },
});

export const Alerts = () => {
  const { alerts, removeAlert } = useAlertStore();
  const networkAlert = useNetworkAlert();

  const allAlerts = [...alerts];
  if (networkAlert) {
    allAlerts.push(networkAlert);
  }

  if (!allAlerts.length) return null;

  return (
    <div className={css.container}>
      {allAlerts.map((alertData) => {
        const buttons: Omit<IAlertButtonProps, 'style'>[] = [];
        if (!alertData.unclosable) {
          buttons.push({
            icon: CloseIcon,
            onClick: () => {
              removeAlert(alertData);
            },
          });
        }

        return (
          <Alert
            key={getAlertId(alertData)}
            title={alertData.title}
            description={alertData.description}
            icon={alertData.icon}
            type={alertData.type}
            buttons={buttons}
          />
        );
      })}
    </div>
  );
};
